import React from 'react';
import { useFormState } from 'react-final-form';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import Grid from '@mui/material/Grid';

import { buildFormField } from '../../../../components/Form/formFieldFactory';
import FormSelectDropdownField from '../../../../components/Form/FormSelectDropdownField';
import theme from '../../../../theme';

import {
  allowBackfillField,
  allowOvertimeField,
  isEnforcingAttendancePolicyField,
  isGPSEnforcedField,
  isPunchingOutsideOfShiftEnabledField,
  punchDistanceField,
  requireEmployerApprovalField,
} from './FormData/AdminFormFieldDataAdditionalData';

const AdminAdditionalDetailsFormBody = () => {
  const formState = useFormState();
  const currentFormValues = formState?.values;

  // Create dynamic field configurations with internationalized options
  const earlyPunchWindowField = {
    ComponentType: FormSelectDropdownField,
    labelKey: 'pt.additionalDetails.earlyPunchWindow',
    name: 'earlyPunchWindow',
    fullWidth: true,
    mode: 'dark',
    variant: 'outlined',
    multiple: false,
    sx: {
      height: '39px',
    },
    options: [
      {
        id: '0',
        name: LanguageConverterV2('pt.additionalDetails.minutes', { minutes: 0 }),
        value: 0,
      },
      {
        id: '5',
        name: LanguageConverterV2('pt.additionalDetails.minutes', { minutes: 5 }),
        value: 5,
      },
      {
        id: '10',
        name: LanguageConverterV2('pt.additionalDetails.minutes', { minutes: 10 }),
        value: 10,
      },
      {
        id: '15',
        name: LanguageConverterV2('pt.additionalDetails.minutes', { minutes: 15 }),
        value: 15,
      },
    ],
  };

  const punchRoundingField = {
    ComponentType: FormSelectDropdownField,
    labelKey: 'pt.additionalDetails.punchRounding',
    name: 'punchRounding',
    fullWidth: true,
    mode: 'dark',
    variant: 'outlined',
    multiple: false,
    sx: {
      height: '39px',
    },
    options: [
      {
        id: '1',
        name: LanguageConverterV2('pt.additionalDetails.minutes', { minutes: 1 }),
        value: 1,
      },
      {
        id: '5',
        name: LanguageConverterV2('pt.additionalDetails.minutes', { minutes: 5 }),
        value: 5,
      },
      {
        id: '10',
        name: LanguageConverterV2('pt.additionalDetails.minutes', { minutes: 10 }),
        value: 10,
      },
      {
        id: '15',
        name: LanguageConverterV2('pt.additionalDetails.minutes', { minutes: 15 }),
        value: 15,
      },
    ],
  };

  return (
    <Grid
      container
      spacing={1}
      direction="column"
      sx={{ width: '100%', color: '#FFF', padding: theme.spacing(2) }}
    >
      <Grid item xs={12} sx={{ margin: theme.spacing(0, 0, 3, 0) }}>
        {buildFormField(requireEmployerApprovalField)}
      </Grid>
      <Grid item xs={12} sx={{ margin: theme.spacing(0, 0, 3, 0) }}>
        {buildFormField(allowBackfillField)}
      </Grid>
      <Grid item xs={12} sx={{ margin: theme.spacing(0, 0, 3, 0) }}>
        {buildFormField(allowOvertimeField)}
      </Grid>
      <Grid item xs={12} sx={{ margin: theme.spacing(0, 0, 3, 0) }}>
        {buildFormField(isEnforcingAttendancePolicyField)}
      </Grid>
      <Grid item xs={12} sx={{ margin: theme.spacing(0, 0, 3, 0) }}>
        {buildFormField(isPunchingOutsideOfShiftEnabledField)}
      </Grid>
      <Grid item xs={12} sx={{ margin: theme.spacing(0, 0, 3, 0) }}>
        {buildFormField(isGPSEnforcedField)}
      </Grid>
      {currentFormValues.gpsEnforced && (
        <Grid item xs={12} sx={{ margin: theme.spacing(0, 0, 3, 0) }}>
          {buildFormField(punchDistanceField)}
        </Grid>
      )}
      <Grid item xs={12} sx={{ margin: theme.spacing(0, 0, 3, 0) }}>
        {buildFormField(earlyPunchWindowField)}
      </Grid>
      <Grid item xs={12} sx={{ margin: theme.spacing(0, 0, 3, 0) }}>
        {buildFormField(punchRoundingField)}
      </Grid>
    </Grid>
  );
};

export default AdminAdditionalDetailsFormBody;
